import { render } from "./CreateUserForm.vue?vue&type=template&id=766acd3a&scoped=true&ts=true"
import script from "./CreateUserForm.vue?vue&type=script&lang=ts"
export * from "./CreateUserForm.vue?vue&type=script&lang=ts"

import "./CreateUserForm.vue?vue&type=style&index=0&id=766acd3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-766acd3a"]])

export default __exports__